import React from 'react';
import useMarketplaceItems from 'new/hooks/adapters/useMarketplaceItems';
import { DatasetHeader } from './DatasetHeader';
import { SharedDatasetDetailsTabs } from './SharedDatasetDetailsTabs';
import { DataProductDrawerHeader, DrawerHeaderPresets } from './DataProductDrawerHeader';
import { useDataProductsDrawer } from '../hooks';

import styles from '../DataProductsDrawer.module.scss';

interface DataProductProps {
  datasetId: number;
  dataset?: any;
  onClose: () => void;
  domainId?: number;
  isRequest?: boolean;
  headerVariant?: 'MARKETPLACE_CONTEXT' | 'DEFAULT';
}

export const DataProduct = (props: DataProductProps) => {
  const {
    onClose,
    domainId,
    datasetId,
    dataset,
    isRequest = false,
    headerVariant = 'MARKETPLACE_CONTEXT',
  } = props;

  const { getMarketplaceItemById } = useMarketplaceItems();
  const { isCustodian } = useDataProductsDrawer(datasetId, domainId);

  const data = headerVariant === 'DEFAULT' ? dataset : getMarketplaceItemById(datasetId);

  if (!data) return null;

  return (
    <div className={styles.container}>
      <DataProductDrawerHeader
        dataset={data}
        domainId={domainId}
        isRequest={isRequest}
        isCustodian={isCustodian}
        onClose={onClose}
        config={DrawerHeaderPresets[headerVariant as keyof typeof DrawerHeaderPresets]}
      />

      <div className={styles.content}>
        <DatasetHeader name={data.name} description={data.description} className={styles.info} />

        <SharedDatasetDetailsTabs dataset={data} initialTab="overview" />
      </div>
    </div>
  );
};
